
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recipes/freeze-dried-raw",
      function () {
        return require("private-next-pages/recipes/freeze-dried-raw/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recipes/freeze-dried-raw"])
      });
    }
  